import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal, Eyebrow } from "../components/Reveal";

export const FAQS = [
  ["How do I buy tickets?", "Select Get Tickets or Buy Tickets on any show. You'll be taken to our official ticketing partner's website to complete your purchase. Prices are in Canadian dollars."],
  ["Is there an age restriction?", "Most shows are all-ages. Anyone under 16 must be accompanied by an adult. Valid government photo ID is required to purchase alcohol (19+ in Ontario)."],
  ["What happens if it rains?", "Concerts are rain or shine. In case of severe weather, show times may be delayed or rescheduled and ticket holders will be notified by email."],
  ["Can I bring food, drinks or a chair?", "Outside food, beverages and chairs are not permitted. Food and drink vendors operate on site. Sealed empty water bottles are allowed."],
  ["What accessibility services are available?", "Accessible viewing platforms, companion seating, accessible washrooms and step-free routes are provided. Service animals are welcome. Contact us before your show for specific needs."],
  ["What is the refund policy?", "All sales are final unless a show is cancelled. If a show is cancelled, refunds are issued automatically to the original payment method."],
  ["Is re-entry permitted?", "No re-entry once you leave the venue. Bags are subject to search; small clear bags are recommended."],
];

export const FaqList = ({ prefix = "faq" }) => (
  <Accordion type="single" collapsible className="divide-y divide-white/10 border-y border-white/10">
    {FAQS.map(([q, a], i) => (
      <AccordionItem key={q} value={`i${i}`} className="border-0">
        <AccordionTrigger data-testid={`${prefix}-trigger-${i}`} className="py-6 text-left font-display text-xl font-bold uppercase text-white hover:no-underline sm:text-2xl">{q}</AccordionTrigger>
        <AccordionContent className="pb-6 text-base text-zinc-300">{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto grid max-w-7xl gap-10 px-5 py-20 lg:grid-cols-12 lg:px-12 lg:py-28">
    <Reveal className="lg:col-span-4">
      <Eyebrow>FAQ & Policies</Eyebrow>
      <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] text-white">Good to know.</h2>
    </Reveal>
    <div className="lg:col-span-8"><FaqList /></div>
  </section>
);
